module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.display),
      expression: "display"
    }]
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(this.$store.state.showHint) ? _c('div', {
    staticClass: "helper"
  }, [_c('div', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.message))]), _vm._v(" "), _c('div', {
    staticClass: "close",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v("x")])]) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-063a1930"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/nav1/Hint.vue
// module id = 888
// module chunks = 170